/**
 * Shared date format constants for consistent date formatting across the application
 */

// Format for displaying dates with time (e.g., "31/12/2023 12:30 PM")
export const DATE_TIME_FORMAT = "DD/MM/YYYY hh:mm A";

// Format for displaying dates without time (e.g., "31/12/2023")
export const DATE_FORMAT = "DD/MM/YYYY";

// Format for DatePicker component with time
export const DATE_PICKER_TIME_FORMAT = "dd/MM/yyyy h:mm aa";

// Format for DatePicker component without time
export const DATE_PICKER_FORMAT = "dd/MM/yyyy";